function threshold(bounds) {
	bounds[0][1] = bounds[0][1] < 0 ? 180 : bounds[0][1];

	return bounds;
}

module.exports = function calcRegionsBounds(r, b) {
	b = b.geometry ? b.geometry.getBounds() : b;

	if(r === null) {
		r = b;
	} else {
		r[0][0] = Math.min(r[0][0], r[1][0], b[0][0], b[1][0]);
		r[0][1] = Math.min(r[0][1], r[1][1], b[0][1], b[1][1]);
		r[1][0] = Math.max(r[0][0], r[1][0], b[0][0], b[1][0]);
		r[1][1] = Math.max(r[0][1], r[1][1], b[0][1], b[1][1]);
	}
	return threshold(r);
};



/** WEBPACK FOOTER **
 ** ./src/scripts/lib/contacts/fn/calcRegionsBounds.js
 **/